module.exports = __webpack_public_path__ + "img/heroBg2.00d34a5f.png";